export default __webpack_public_path__ + "static/media/r8.f109ecdb.jpg";